import { getProducts } from "@/api/endpoints";
import { RecordListPage } from "@/components/record-list-page";
import { Badge } from "@/components/ui/primitives";
import { useI18n } from "@/i18n";
import type { Product } from "@/types";

export function ProductsPage() {
  const { t } = useI18n();

  return (
    <RecordListPage<Product>
      title={t("navProducts")}
      resource="products"
      fetcher={getProducts}
      renderRow={(product) => (
        <div className="flex items-center gap-3">
          <div className="min-w-0 flex-1">
            <p className="truncate font-medium">{product.name}</p>
            {product.description && (
              <p className="truncate text-sm text-muted-foreground">{product.description}</p>
            )}
          </div>
          {product.code && <Badge>{product.code}</Badge>}
        </div>
      )}
    />
  );
}
